import { render, staticRenderFns } from "./DeductiblesQuotatorProportional.vue?vue&type=template&id=fb38372a&scoped=true&"
import script from "./DeductiblesQuotatorProportional.vue?vue&type=script&lang=js&"
export * from "./DeductiblesQuotatorProportional.vue?vue&type=script&lang=js&"
import style0 from "./DeductiblesQuotatorProportional.vue?vue&type=style&index=0&id=fb38372a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb38372a",
  null
  
)

export default component.exports